
    import './styles.scoped.css';
    export default {
  "background-fill": "awsui_background-fill_1fi2u_1ry7x_9",
  "content": "awsui_content_1fi2u_1ry7x_14"
};
  